export default "__VITE_ASSET__MpDszeVa__"